import Calc from "@/common/util/calculator"
import BaseScrewFixmethod from "@/signomatic/app/fixmethods/base_screw"

export default class ScrewStainlessFixmethod extends BaseScrewFixmethod {
  positions() {
    const { widthPx, heightPx } = this.state
    const positions = []
    const diameter = Calc.mmToPx(3.5)
    const headDiameter = Calc.mmToPx(5)
    const distance = Calc.mmToPx(4)

    const left = distance
    const right = widthPx - distance
    const centerV = heightPx / 2
    const flathead = false

    const top = distance
    const bottom = heightPx - distance

    const defaults = { diameter, headDiameter, flathead }

    if (
      this.drawables.state.width < 50 &&
      this.drawables.state.height < 50 &&
      ["ellipse", "stop", "arched_top_bottom"].includes(this.drawables.state.shape)
    ) {
      positions.push({ ...defaults, left, top: top })
      positions.push({ ...defaults, left, top: bottom, stretch: true })
    } else if (
      ((this.drawables.state.width >= 100 && this.drawables.state.height >= 40) ||
        (this.drawables.state.width >= 40 && this.drawables.state.height >= 100)) &&
      !["ellipse", "stop"].includes(this.drawables.state.shape)
    ) {
      positions.push({ ...defaults, left, top: top })
      positions.push({ ...defaults, left: right, top: top })
      positions.push({ ...defaults, left, top: bottom })
      positions.push({ ...defaults, left: right, top: bottom })
    } else {
      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    }

    return positions
  }
}
